// Portfolio.js

import React from "react";
import "./Portfolio.css";

const projects = [
  {
    title: "SPRINGER LINK",
    description:
      "this project was for civil engineering institute whose emplement using " +
      "css, html,java script, react, php, and laravel.",
    link: "https://link.springer.com/journal/40996",
  },
  {
    title: "COMPUTER ZONE",
    description:
      "this is was my another project wich i implement using HTML,CSS ,BootStrap, javaScript, php, and laravel. ",
    link: "https://www.czone.com.pk/",
  },
  {
    title: "Egypt to Afghanistan",
    description:
      "this was another project wich i implement in html, css, talwind,java script, react and php.",
    link: "https://www.rome2rio.com/s/Egypt/Afghanistan",
  },
  {
    title: "DARAZ",
    description:
      "this was another one for computer shop using html, css, javascipt, php, and laravel.",
    link: "https://www.daraz.pk/desktop-computer/",
  },
  // Add more projects as needed
];

const Portfolio = () => {
  return (
    <div className="portfolio-container">
      <h2>My Portfolio</h2>
      <div className="projects">
        {projects.map((project, index) => (
          <div className="project" key={index}>
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              View Project
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
